module.exports = __webpack_public_path__ + "img/wc.07b1ad97.svg";